import useCachedList from '../base/useCachedList';
import { useFindProductionListLazy } from './useFindProductionsList';
import ProductionDTO from '@src/adapters/dto/production/ProductionDTO';

type FindLazyResult = { items: ProductionDTO[] };

const useCachedProductionList = () => {
  return useCachedList<ProductionDTO, FindLazyResult>(
    'productionList',
    useFindProductionListLazy,
    'items'
  );
};

export default useCachedProductionList;
